import { Card, Typography, Chip, Stack, Button, Collapse } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

import MissingDataCardItemMoreMetrics from "./MissingDataCardItemMoreMetrics";
import MissingDataCardItemLastRun from "./MissingDataCardItemLastRun";

// ─────────────────────────────────────────────────────────────────────────────

//type StatusColor = "success" | "error";

interface MissingDataCardItemViewProps {
  website_name: string;
  website_id: string;

  qftd: string;
  qftds: string;
  qftd_status: string;
  qftd_percentage: string;
  budget_dollar: string;
  budgets_dollar: string;
  budget_status: string;
  budget_percentage: string;
  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;

  runDate: string;
  runRange: string;
  runBy: string;
  status: string;
}

export function MissingDataCardItemView({
  website_name,
  website_id,
  qftd,
  qftds,
  budget_status,
  budget_percentage,
  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  cpa_budget_dollar,
  ftd,
  runDate,
  runRange,
  runBy,
  status,
}: MissingDataCardItemViewProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            {website_name} ({website_id})
          </Typography>
          <MissingDataCardItemLastRun
            title={website_name}
            brandId={website_id}
            runDate={runDate}
            runRange={runRange}
            runBy={runBy}
            status={status}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={spacing.Spacing.md.$value}
          mb={spacing.Spacing.xs.$value}
        >
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {qftd}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              Click out, of which:
            </Typography>
          </Box>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          mt={spacing.Spacing.md.$value}
          mb={spacing.Spacing.md.$value}
        >
          <Box
            sx={{
              width: "50%",
              pr: spacing.Spacing.md.$value,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              FTD
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.sm.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {ftd}
              </Typography>
              <Chip
                label={budget_percentage}
                size="small"
                sx={{
                  borderRadius: spacing.Radius.xs.$value,
                  fontSize: typography.Size.Text.sm.$value,
                  mr: spacing.Spacing.sm.$value,
                  bgcolor:
                    budget_status === "success"
                      ? colors.Success[50].$value
                      : budget_status === "warning"
                        ? colors.Warning[50].$value
                        : colors.Error[50].$value,

                  color:
                    budget_status === "success"
                      ? colors.Success[600].$value
                      : budget_status === "warning"
                        ? colors.Warning[600].$value
                        : colors.Error[600].$value,

                  fontWeight: typography.Font_weight.Semibold.$value,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              width: "50%",
              borderLeft: "1px solid" + colors.GrayLightMode[200].$value,
              pl: spacing.Spacing.md.$value,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              QFTD
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.sm.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {qftd}
              </Typography>
              <Chip
                label={budget_percentage}
                size="small"
                sx={{
                  borderRadius: spacing.Radius.xs.$value,
                  fontSize: typography.Size.Text.sm.$value,
                  mr: spacing.Spacing.sm.$value,
                  bgcolor:
                    budget_status === "success"
                      ? colors.Success[50].$value
                      : budget_status === "warning"
                        ? colors.Warning[50].$value
                        : colors.Error[50].$value,

                  color:
                    budget_status === "success"
                      ? colors.Success[600].$value
                      : budget_status === "warning"
                        ? colors.Warning[600].$value
                        : colors.Error[600].$value,

                  fontWeight: typography.Font_weight.Semibold.$value,
                }}
              />
            </Box>
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={spacing.Spacing["2xl"].$value}
          mb={spacing.Spacing.xs.$value}
        >
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              Total Income
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {qftds}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              , of which:
            </Typography>
          </Box>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          mt={spacing.Spacing.md.$value}
          mb={spacing.Spacing.md.$value}
        >
          <Box
            sx={{
              width: "50%",
              pr: spacing.Spacing.md.$value,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              CAP
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.sm.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {qftds}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: "50%",
              borderLeft: "1px solid" + colors.GrayLightMode[200].$value,
              pl: spacing.Spacing.md.$value,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              RS
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.sm.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {qftds}
              </Typography>
            </Box>
          </Box>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="center">
          <Button
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              padding: "0",
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              color: colors.Brand[800].$value,
              fontWeight: typography.Font_weight.Regular.$value,
              textTransform: "capitalize",
              letterSpacing: "0px",
            }}
            data-tracker="654"
          >
            {open ? "Less More Metrics" : "Show More Metrics"}
            <ExpandMoreIcon
              sx={{
                color: colors.Brand[800].$value,
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "0.2s",
              }}
            />
          </Button>
        </Stack>
        <Stack>
          {/* Expandable Info */}
          <Collapse in={open}>
            <MissingDataCardItemMoreMetrics
              remaining_qftd={remaining_qftd}
              cpa_income_dollar={cpa_income_dollar}
              total_income_dollar={total_income_dollar}
              cpa_budget_dollar={cpa_budget_dollar}
              ftd={ftd}
            />
          </Collapse>
        </Stack>
      </Card>
    </>
  );
}
export default MissingDataCardItemView;
